__webpack_require__.p = "/portfolio-project-1/";